import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.691 5.912a2.985 2.985 0 0 0-2.9-2.283H6.508a2.283 2.283 0 0 0-.421 4.527l5.558 1.042a2.609 2.609 0 0 1-.48 5.173H6.612a2.39 2.39 0 0 1-2.312-1.79M9 16.758V1.242"
    }, null, -1)
  ])))
}
export default { render: render }